import { render } from "./FocusRingPage.vue?vue&type=template&id=18bfeec3&ts=true"
import script from "./FocusRingPage.vue?vue&type=script&lang=ts"
export * from "./FocusRingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__